import React, { PropTypes, Component } from 'react'
import styles from './styles'
import AutoComplete from 'components/autocomplete'

export default class HeaderAutocompleteCell extends Component {
  static propTypes = {
    baseClass: PropTypes.string,
    text: PropTypes.string,
    items: PropTypes.array,
    pid: PropTypes.string,
    tid: PropTypes.string,
    tasks: PropTypes.array,
    onContentCodeChange: PropTypes.func,
  };

  constructor (props, context) {
    super(props, context)
  }

  render () {
    const { baseClass, text, items, pid, tid, tasks } = this.props
    const cname = `${baseClass} ${styles.headerAutocompleteCell}`

    const onSelect = (item) => {
      let newId = null
      tasks.forEach(task => {
        if (task.name === item) {
          newId = task._id
        }
      })
      this.props.onContentCodeChange(pid, tid, newId)
    }

    return (
      <div className={cname} >
        <AutoComplete {...{
          value: text,
          onSelect,
          items,
        }} dropDown expand
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/timesheet/cell/headerAutocompleteCell.jsx